import { render, staticRenderFns } from "./DoctorPlan.vue?vue&type=template&id=60e64a8d&scoped=true&"
import script from "./DoctorPlan.vue?vue&type=script&lang=js&"
export * from "./DoctorPlan.vue?vue&type=script&lang=js&"
import style0 from "./DoctorPlan.vue?vue&type=style&index=0&id=60e64a8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e64a8d",
  null
  
)

export default component.exports